import React from "react";
import {InfoCircleOutlined} from "@ant-design/icons";
import {StyledShortCodeCard} from "../../automations.style";
import {SHORT_CODES} from "./constants";

interface ShortCodesListProps {
  onInsertShortCode: (code: string) => void;
}

export function ShortCodesList({onInsertShortCode}: ShortCodesListProps) {
  return (
    <>
      <p style={{fontSize: "16px", color: "#595959", marginBottom: "24px"}}>
        Short codes are placeholders that are replaced with real data when the email is
        sent.
      </p>

      {SHORT_CODES.map((item) => (
        <StyledShortCodeCard key={item.code} onClick={() => onInsertShortCode(item.code)}>
          <div className="short-code-title">{item.code}</div>
          <div className="short-code-desc">{item.desc}</div>
        </StyledShortCodeCard>
      ))}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginTop: "32px",
          color: "#595959",
          fontSize: "14px",
        }}
      >
        <InfoCircleOutlined />
        <span>Select a short code to insert into your editor at the cursor position</span>
      </div>
    </>
  );
}
